// Matches the banner's `h-8` (32px) + border-b (1px). Keep in sync with
// MaintenanceOverrideBanner / OfflineBanner / PrefetchProgressBar — the three
// surfaces still entitled to a row of app chrome. Background sync and the
// slow-connection suggestion left this stack on 2026-08-26 (2px hairline and
// a bottom card); `BackgroundSyncIndicator` still reads the offset so it can
// ride at the bottom edge of whatever is reserved, but it adds nothing.
export const TOP_STATUS_BANNER_HEIGHT_PX = 33

type BannerOffsetParams = {
  bannerIndex: number
}

type ContentOffsetParams = {
  hasMaintenanceBanner?: boolean
  hasStatusBanner: boolean
  hasPrefetchBanner: boolean
}

export function getTopBannerOffsetPx({ bannerIndex }: BannerOffsetParams): number {
  return Math.max(0, bannerIndex) * TOP_STATUS_BANNER_HEIGHT_PX
}

// Background sync is intentionally excluded — it renders as a 2px hairline
// that overlays content instead of reserving space, so transient fetches
// don't trigger a layout shift on every query refresh. It used to be a
// 33px text banner under the same exemption, which meant every refetch
// covered a row of real UI: measured at 375px it hid 32 of the mobile
// topbar's 53px.
export function getTopBannerContentOffsetPx({
  hasMaintenanceBanner,
  hasStatusBanner,
  hasPrefetchBanner,
}: ContentOffsetParams): number {
  const bannerCount =
    (hasMaintenanceBanner ? 1 : 0) + Number(hasStatusBanner) + Number(hasPrefetchBanner)
  return bannerCount * TOP_STATUS_BANNER_HEIGHT_PX
}
